import { Error } from '../ErrorHandling';

export interface ChatMessageContent {
  html: string;
  text: string;
}

export const emptyChatMessageContent = (): ChatMessageContent => ({ html: '', text: '' });

interface Waiting {
  kind: 'waiting';
}

interface Ready {
  kind: 'ready';
  message: ChatMessageContent;
}

interface Updating {
  kind: 'updating';
  message: ChatMessageContent;
}

interface Broadcasting {
  kind: 'broadcasting';
  message: ChatMessageContent;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const reset = (): Ready => ({
  kind: 'ready',
  message: emptyChatMessageContent(),
});

export const ready = (message: ChatMessageContent): Ready => ({
  kind: 'ready',
  message: message,
});

export const updating = (message: ChatMessageContent): Updating => ({
  kind: 'updating',
  message: message,
});

export const broadcasting = (message: ChatMessageContent): Broadcasting => ({
  kind: 'broadcasting',
  message: message,
});

export type ChatMessageState = Ready | Updating | Waiting | Broadcasting | Error;
